import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi, putApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";

// --- THUNKS ---

// Fetch Form Assignments (Table Data)
// export const fetchFormAssignments = createAsyncThunk(
//   "viewForm/fetchAssignments",
//   async ({ formId, isEmployee }, { rejectWithValue }) => {
//     try {
//       const apiUrl = isEmployee
//         ? API_URLS.GET_EMP_FORM_ALLOTMENT_HIERARCHY(formId)
//         : API_URLS.GET_CLIENT_FORM_ALLOTMENT_HIERARCHY(formId);

//       const response = await getApi({
//         apiUrl,
//       });
//       return response?.data ?? response;
//     } catch (error) {
//       return rejectWithValue(
//         error?.response?.data?.message ||
//         error?.message ||
//         "Failed to fetch assignments",
//       );
//     }
//   },
// );
export const fetchFormAssignments = createAsyncThunk(
  "viewForm/fetchAssignments",
  async (
    { formId, isEmployee, skip = 0, limit = 10, projectId = "" },
    { rejectWithValue },
  ) => {
    try {
      const resolvedProjectId =
        typeof projectId === "object" ? projectId?._id : projectId;
      const apiUrl = isEmployee
        ? API_URLS.GET_EMP_FORM_ALLOTMENT_HIERARCHY(
            formId,
            skip,
            limit,
            resolvedProjectId,
          )
        : API_URLS.GET_CLIENT_FORM_ALLOTMENT_HIERARCHY(
            formId,
            skip,
            limit,
            resolvedProjectId,
          );

      const response = await getApi({ apiUrl });

      // ✅ Poora response return karo, sirf .data nahi
      return response; // { success, data: [...], total, limit, skip }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch assignments",
      );
    }
  },
);

// Fetch Form Details (Header Section)
export const fetchFormDetails = createAsyncThunk(
  "viewForm/fetchDetails",
  async (formId, { rejectWithValue }) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_FORM_DETAILS(formId),
      });
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch form details",
      );
    }
  },
);

// Fetch Project Details by ID
export const fetchProjectById = createAsyncThunk(
  "viewForm/fetchProjectById",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_PROJECT_BY_ID(projectId),
      });
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch project details",
      );
    }
  },
);

// Authorize Form Manage (LS1)
export const authorizeFormManage = createAsyncThunk(
  "viewForm/authorizeManage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.AUTHORIZE_FORM_MANAGE,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Authorization failed",
      );
    }
  },
);

// Authorize Form Manage LS2
export const authorizeFormManageLS2 = createAsyncThunk(
  "viewForm/authorizeManageLS2",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.AUTHORIZE_FORM_MANAGE_LS2,
        data: payload,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "LS2 Authorization failed",
      );
    }
  },
);

// --- SLICE ---

const initialState = {
  assignments: [],
  details: null,
  projectDetails: null,
  loading: false,
  error: null,
  success: false,
  actionLoading: false,
  assignments: [],
  assignmentsTotal: 0,
  assignmentsLimit: 10,
  assignmentsSkip: 0,
};

const viewFormSlice = createSlice({
  name: "viewForm",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.success = false;
      state.error = null;
    },
    resetViewFormState: (state) => {
      state.assignments = [];
      state.details = null;
      state.projectDetails = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Assignments
      .addCase(fetchFormAssignments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFormAssignments.fulfilled, (state, action) => {
        state.loading = false;
        state.assignments = action.payload || [];
        state.assignments = action.payload.data || [];
        state.assignmentsTotal = action.payload.total || 0;
        state.assignmentsLimit = action.payload.limit || 10;
        state.assignmentsSkip = action.payload.skip || 0;
      })
      .addCase(fetchFormAssignments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Details
      .addCase(fetchFormDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFormDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
      })
      .addCase(fetchFormDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Authorize Manage
      .addCase(authorizeFormManage.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(authorizeFormManage.fulfilled, (state) => {
        state.actionLoading = false;
        state.success = true;
      })
      .addCase(authorizeFormManage.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      // Authorize LS2
      .addCase(authorizeFormManageLS2.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(authorizeFormManageLS2.fulfilled, (state) => {
        state.actionLoading = false;
        state.success = true;
      })
      .addCase(authorizeFormManageLS2.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      // Fetch Project Details
      .addCase(fetchProjectById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectDetails = action.payload;
      })
      .addCase(fetchProjectById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStatus, resetViewFormState } = viewFormSlice.actions;
export default viewFormSlice.reducer;
